
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wholesale-parts-hub/parts-ordering",
      function () {
        return require("private-next-pages/wholesale-parts-hub/parts-ordering.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wholesale-parts-hub/parts-ordering"])
      });
    }
  